import type { EAPFeature } from '.';

export const features: EAPFeature[] = [
    {
        id: 'pulseEnps',
        name: 'eNPS support in Pulse Surveys',
        description: 'Automatically calculated eNPS scores are coming to Pulse Surveys.',
        descriptionLong: (
            <>
                <p>
                    We're adding eNPS (Employee Net Promoter Score) support to Pulse Surveys. Admins will be able to add
                    an eNPS question to any Pulse survey, with its own independent scale so it works alongside your
                    existing survey setup.
                </p>
                <p>
                    The eNPS score will be automatically calculated and displayed with your survey results, no manual
                    calculations needed.
                </p>
                <p>Stay tuned for more information.</p>
            </>
        ),
        type: 'waitlist',
        imgSrc: require('./images/pulse-enps.png'),
    },
    {
        id: 'inbox',
        name: 'Inbox',
        description: 'Never miss notifications anymore thanks to the new Inbox',
        descriptionLong: (
            <>
                <p>
                    Notifications deserve a proper place on the main menu so that users can interact with the content
                    immediately. Your manager left a comment on your objective? Take note and reply right away.
                </p>
                <p>
                    Try our clickable prototype for 1:1s and Objectives, and let us know what’s important to you and
                    your employees.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_inboxPage',
        imgSrc: require('./images/inbox.png'),
        hideIfDisabled: true,
    },
];
